export const Style = {
  SUPERIMPOSE:
    'flex-direction: column;display: inline-flex;justify-content: center;text-align: left;vertical-align: middle;',
  SUPERIMPOSE_SUP_SUB: 'line-height: 1; font-size: 70%',
};
